import React from 'react';
import {
    Box,
    Button,
    Card,
    CircularProgress,
    Grid2 as Grid,
    InputAdornment,
    Stack,
    TextField,
    useTheme,
} from "@mui/material";
import {
    BusinessRounded,
    EmailRounded,
    LocationOnRounded,
    PhoneRounded,
    SaveRounded,
} from "@mui/icons-material";

const _CorporateForm = ({
    inCorporate,
    setInCorporate,
    saving,
    onSave,
}) => {
    const theme = useTheme();

    return (
        <Card
            elevation={0}
            sx={{
                p: { xs: 2.5, sm: 3.5 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            }}
        >
            <Box component="form" onSubmit={onSave}>
                <Stack spacing={2.5}>
                    <TextField
                        fullWidth
                        label="نام رسمی سازمان *"
                        value={inCorporate.Name || ""}
                        onChange={(e) => setInCorporate({ ...inCorporate, Name: e.target.value })}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <BusinessRounded color="action" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                    />

                    <Grid container spacing={2.5}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="ایمیل سازمانی"
                                type="email"
                                value={inCorporate.Email || ""}
                                onChange={(e) => setInCorporate({ ...inCorporate, Email: e.target.value })}
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailRounded color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="شماره تلفن ثابت / داخلی"
                                value={inCorporate.Tel || ""}
                                onChange={(e) => setInCorporate({ ...inCorporate, Tel: e.target.value })}
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PhoneRounded color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                            />
                        </Grid>
                    </Grid>

                    <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={5}
                        label="آدرس دفتر مرکزی / سازمان"
                        value={inCorporate.Address || ""}
                        onChange={(e) => setInCorporate({ ...inCorporate, Address: e.target.value })}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 1.5 }}>
                                    <LocationOnRounded color="action" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={saving || !inCorporate?.Name?.trim()}
                            startIcon={saving ? <CircularProgress size={18} color="inherit" /> : <SaveRounded />}
                            sx={{
                                borderRadius: 3,
                                px: 4,
                                py: 1.2,
                                fontWeight: 700,
                                boxShadow: '0 8px 16px rgba(45, 107, 226, 0.25)',
                            }}
                        >
                            {saving ? "در حال ذخیره..." : "ذخیره تغییرات سازمان"}
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Card>
    );
};

export default _CorporateForm;
